import React from "react";
import "@/App.css";
import LandingPageEgypte from "./pages/LandingPageEgypte";
import "./pages/LandingPageEgypte.css";

function App() {
  return (
    <div className="App">
      <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&family=Poppins:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css" />
      <LandingPageEgypte />
    </div>
  );
}

export default App;
